import { Host, h } from "@stencil/core";
import { exportParts } from "../../common/export-parts";
export class GxgTreeItem {
    constructor() {
        this.horizontalLinePaddingLeft = 0;
        this.lastTreeItem = false;
        this.lastTreeItemOfParentTree = false;
        this.numberOfVisibleDescendantItems = 0;
        this.time = 0;
        this.lineHeight = undefined;
        this.downloading = false;
        this.checkbox = undefined;
        this.checked = undefined;
        this.opened = undefined;
        this.toggleCheckboxes = undefined;
        this.type = undefined;
        this.disabled = undefined;
        this.label = undefined;
        this.description = undefined;
        this.leaf = false;
        this.selected = false;
        this.icon = undefined;
        this.treeModel = undefined;
        this.numberOfChildren = 0;
        this.hasChildTree = false;
        this.indeterminate = false;
    }
    /*
  INDEX:
  1.OWN PROPERTIES
  2.REFERENCE TO ELEMENTS
  3.STATE() VARIABLES
  4.PUBLIC PROPERTY API | WATCH'S
  5.EVENTS (EMIT)
  6.COMPONENT LIFECYCLE METHODS
  7.LISTENERS
  8.PUBLIC METHODS API
  9.LOCAL METHODS
  10.RENDER() FUNCTION
  */
    // 1.OWN PROPERTIES //
    id;
    lazy = false; //True if not leaf but no children.
    parentTreeIsMasterTree = false;
    numberOfParentTrees = 1;
    firstItem = false;
    lastItem = false;
    leftPadding = "0px";
    verticalLineStartPosition = "0px";
    horizontalLineWidth = "24px";
    horizontalLineStartPosition = "0px";
    parts = {
        item: "item",
        checkbox: "checkbox",
        toggleButton: "toggle-button"
    };
    exportparts;
    // 2. REFERENCE TO ELEMENTS //
    el;
    checkedHandler(_, oldValue) {
        if (oldValue !== undefined) {
            this.checkboxToggled.emit(this.getItemData(false));
        }
    }
    openedHandler(_, oldValue) {
        if (oldValue !== undefined) {
            this.toggleIconClicked.emit(this.getItemData(false));
        }
    }
    // 5.EVENTS (EMIT) //
    /**
     * Emitted when the checkbox was toggled
     */
    checkboxToggled;
    /**
     * Emitted when the item was double-clicked
     */
    doubleClicked;
    /**
     * Emitted when the item is not lazy anymore
     */
    lazyChanged;
    /**
     * Emitted when the icon selection was changes
     */
    selectionChanged;
    /**
     * Emitted when the toggle icon was clicked
     */
    toggleIconClicked;
    // 6.COMPONENT LIFECYCLE METHODS //
    componentWillLoad() {
        //Count number of parent trees in order to set the appropriate padding-left
        this.numberOfParentTrees = this.getParentsNumber();
        this.numberOfChildren = this.getChildrenNumber();
        //If is last item of tree
        const nextItem = this.el.nextElementSibling;
        if (nextItem === null) {
            this.lastTreeItem = true;
        }
        if (this.numberOfParentTrees === 1) {
            this.parentTreeIsMasterTree = true;
            const prevItem = this.el.previousElementSibling;
            if (prevItem === null) {
                //If is first item of parent tree...
                this.firstItem = true;
            }
        }
        if (!this.el.nextElementSibling) {
            this.lastItem = true;
        }
        this.evaluateId();
        this.evaluateLazy();
        this.defineLineHeight();
        this.defineStartPosition();
        this.cascadeConfig();
        this.attachExportParts();
        this.initiateMutationObserver();
    }
    // 7.LISTENERS //
    // 8.PUBLIC METHODS API //
    async reRender() {
        this.defineLineHeight();
    }
    evaluateCheckboxStatus() {
        const allChildren = this.el.querySelectorAll("gxg-tree-item");
        let checked = 0;
        if (allChildren?.length) {
            Array.from(allChildren).forEach(item => {
                if (item.checked) {
                    checked++;
                }
            });
            if (allChildren.length === checked) {
                //all checked
                this.checked = true;
                this.indeterminate = false;
            }
            else if (checked === 0) {
                //all unchecked
                this.checked = false;
                this.indeterminate = false;
            }
            else {
                //indeterminate
                this.indeterminate = true;
            }
        }
    }
    // 9.LOCAL METHODS //
    evaluateId = () => {
        if (!this.id) {
            this.id = this.el.getAttribute("id");
        }
    };
    evaluateLazy = () => {
        if (!this.leaf && this.numberOfChildren === 0) {
            this.lazy = true;
            this.opened = false;
        }
    };
    observer = new MutationObserver(mutationsList => {
        for (const mutation of mutationsList) {
            if (mutation.type === "childList") {
                this.lazy = false;
                this.opened = true;
                this.reRender();
                this.openedHandler;
            }
        }
    });
    initiateMutationObserver = () => {
        this.observer.observe(this.el, { childList: true, subtree: true });
    };
    /**
     * @description Set some properties based on the parent tree configuration, unless this item has this properties already set.
     */
    cascadeConfig = () => {
        const parentTree = this.el
            .parentElement;
        this.checkbox =
            this.checkbox !== undefined ? this.checkbox : parentTree.checkbox;
        this.checked =
            this.checked !== undefined ? this.checked : parentTree.checked;
        this.opened = this.opened !== undefined ? this.opened : parentTree.opened;
        this.toggleCheckboxes =
            this.toggleCheckboxes !== undefined
                ? this.toggleCheckboxes
                : parentTree.checkbox;
    };
    attachExportParts = () => {
        const part = this.el.getAttribute("part");
        const exportPartsResult = exportParts(part, this.parts);
        exportPartsResult.length && (this.exportparts = exportPartsResult);
    };
    defineLineHeight = () => {
        let offset = 11.5;
        if (this.parentTreeIsMasterTree) {
            offset = 0;
            if (this.lastItem) {
                offset = 11;
            }
        }
        let total = 0;
        if (!this.leaf && !this.lazy) {
            const allItemsLength = this.el.querySelectorAll("gxg-tree-item").length;
            const directGxgTree = this.el.querySelector(":scope > gxg-tree");
            const directTreeItems = directGxgTree.querySelectorAll(":scope > gxg-tree-item");
            if (!this.parentTreeIsMasterTree) {
                const lastDirectTreeItem = directTreeItems[directTreeItems.length - 1];
                const lastDirectItemItemsLength = lastDirectTreeItem.querySelectorAll("gxg-tree-item").length;
                total = allItemsLength - lastDirectItemItemsLength;
            }
            else {
                total = allItemsLength;
            }
        }
        this.lineHeight = `${total * 24.2 - offset}px`;
    };
    /**
     * @description returns the appropriate start padding and start position for the item, horizontal line, and vertical line.
     */
    defineStartPosition = () => {
        let value = 0;
        let horizontalLineStartPosition = 13;
        if (this.numberOfParentTrees > 1) {
            value = (this.numberOfParentTrees - 1) * 45;
            if (this.numberOfParentTrees > 2) {
                horizontalLineStartPosition = value - 36;
            }
        }
        else {
            value = 5;
        }
        this.verticalLineStartPosition = `${value + 7}px`;
        this.leftPadding = `${value}px`;
        this.horizontalLineStartPosition = `${horizontalLineStartPosition}px`;
    };
    liTextClickedHandler = (e) => {
        const toggleWasClicked = e.target.classList.contains("toggle-icon");
        const checkboxClicked = e.target.nodeName === "GXG-FORM-CHECKBOX";
        if (toggleWasClicked || checkboxClicked)
            return;
        if (e.ctrlKey) {
            this.selected = !this.selected;
        }
        else {
            this.selected = true;
        }
        this.selectionChanged.emit(this.getItemData(e.ctrlKey));
    };
    liTextDoubleClicked = () => {
        this.doubleClicked.emit(this.getItemData(false));
        !this.leaf && this.toggleClickedHandler();
    };
    liTextKeyDownPressed = (e) => {
        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            e.preventDefault(); //prevents scrolling
        }
        //ENTER
        if (e.key === "Enter") {
            //Enter should check/uncheck the checkbox (if present)
            this.checkboxClickedHandler();
        }
        //LEFT/RIGHT NAVIGATION
        if (e.key === "ArrowRight" && !this.leaf) {
            //Toggle the tree
            if (!this.opened) {
                this.opened = true;
            }
            else {
                const childTree = this.el.querySelector("gxg-tree");
                const childTreeFirstChildren = childTree.querySelector("gxg-tree-item");
                const childTreeFirstChildrenLiText = childTreeFirstChildren.shadowRoot.querySelector(".li-text");
                childTreeFirstChildrenLiText.focus();
            }
        }
        if (e.key === "ArrowLeft") {
            let hasParent = false;
            const parentGxgTreeItem = this.el.parentElement.parentElement;
            let parentGxgTreeItemLiText = null;
            if (parentGxgTreeItem.tagName === "GXG-TREE-ITEM") {
                hasParent = true;
                parentGxgTreeItemLiText = parentGxgTreeItem.shadowRoot.querySelector(".li-text");
            }
            if (this.leaf) {
                if (hasParent) {
                    parentGxgTreeItemLiText.focus();
                }
            }
            else {
                const li = this.el.shadowRoot.querySelector("li");
                if (li.classList.contains("tree-open")) {
                    this.opened = false;
                }
                else {
                    if (hasParent) {
                        parentGxgTreeItemLiText.focus();
                    }
                }
            }
        }
        // UP/DOWN NAVIGATION
        if (e.key === "ArrowUp" || (e.key === "Tab" && e.shiftKey)) {
            e.preventDefault();
            if (!this.firstItem) {
                //Is not the first element of the parent
                //Set focus on the prev item
                let prevItem;
                const prevElementSibling = this.el.previousElementSibling;
                if (e.shiftKey && e.key !== "Tab") {
                    //if shift key was pressed, navigate to the previous sibling
                    if (prevElementSibling !== null) {
                        prevItem =
                            prevElementSibling.shadowRoot.querySelector("li .li-text");
                    }
                }
                else {
                    if (prevElementSibling === null) {
                        const parentItem = this.el.parentElement;
                        const parentParentItem = parentItem.parentElement;
                        prevItem = parentParentItem.shadowRoot.querySelector("li .li-text");
                    }
                    else {
                        prevItem =
                            prevElementSibling.shadowRoot.querySelector("li .li-text");
                        if (prevElementSibling !== null) {
                            //If the preceding tree-item has tree inside...
                            const prevElementSiblingHasChildTree = prevElementSibling.hasChildTree;
                            if (prevElementSiblingHasChildTree) {
                                const prevElementSiblingHasOpenTree = prevElementSibling.opened;
                                if (prevElementSiblingHasOpenTree) {
                                    //If preceding tree-item tree is opened, then the prev item is the last item of that tree
                                    const prevElemSiblingTreeItem = this.el.previousElementSibling;
                                    const prevElemSiblingTreeItemTree = prevElemSiblingTreeItem.querySelector("gxg-tree");
                                    //
                                    if (prevElemSiblingTreeItemTree.lastElementChild.hasChildTree) {
                                        if (prevElemSiblingTreeItemTree.lastElementChild.shadowRoot
                                            .querySelector("li")
                                            .classList.contains("tree-open")) {
                                            prevItem = prevElemSiblingTreeItemTree.lastElementChild
                                                .querySelector("gxg-tree")
                                                .lastElementChild.shadowRoot.querySelector("li .li-text");
                                        }
                                        else {
                                            prevItem =
                                                prevElemSiblingTreeItemTree.lastElementChild.shadowRoot.querySelector("li .li-text");
                                        }
                                    }
                                    else {
                                        prevItem =
                                            prevElemSiblingTreeItemTree.lastElementChild.shadowRoot.querySelector("li .li-text");
                                    }
                                    //
                                }
                                else {
                                    //The preciding item has a tree, but it is closed
                                    prevItem =
                                        this.el.previousElementSibling.shadowRoot.querySelector("li .li-text");
                                }
                            }
                        }
                    }
                }
                if (prevItem !== null && prevItem !== undefined) {
                    prevItem.focus();
                }
            }
        }
        if (e.key === "ArrowDown" || (e.key === "Tab" && !e.shiftKey)) {
            e.preventDefault();
            if (!this.lastTreeItemOfParentTree) {
                //Set focus on the next item
                let nextItem;
                if (e.shiftKey) {
                    //if shift key was pressed, navigate to the next sibling
                    if (this.el.nextElementSibling !== null) {
                        nextItem =
                            this.el.nextElementSibling.shadowRoot.querySelector("li .li-text");
                    }
                }
                else {
                    if (this.lastTreeItem) {
                        if (this.hasChildTree && this.opened) {
                            nextItem =
                                this.el.firstElementChild.firstElementChild.shadowRoot.querySelector(".li-text");
                        }
                        else {
                            const thisTree = this.el.parentElement;
                            const thisTreeParent = thisTree.parentElement;
                            const thisTreeParentNextTree = thisTreeParent.nextElementSibling;
                            if (thisTreeParentNextTree === null) {
                                if (thisTreeParent.parentElement.parentElement
                                    .nextElementSibling !== null) {
                                    nextItem =
                                        thisTreeParent.parentElement.parentElement.nextElementSibling.shadowRoot.querySelector(".li-text");
                                }
                            }
                            else {
                                nextItem = thisTreeParentNextTree.shadowRoot.querySelector(".li-text");
                            }
                        }
                    }
                    else {
                        if (this.hasChildTree && this.opened) {
                            nextItem = this.el
                                .querySelector("gxg-tree gxg-tree-item")
                                .shadowRoot.querySelector("li .li-text");
                        }
                        else {
                            nextItem =
                                this.el.nextElementSibling.shadowRoot.querySelector(".li-text");
                        }
                    }
                }
                if (nextItem !== null && nextItem !== undefined) {
                    nextItem.focus();
                }
            }
            else {
                //Last element of parent tree
                if (!this.leaf && this.opened) {
                    const childTreeFirstTreeItem = this.el.firstElementChild.firstElementChild.shadowRoot.querySelector("li .li-text");
                    childTreeFirstTreeItem.focus();
                }
            }
        }
    };
    returnToggleIconType = () => {
        //Returns the type of icon : expand or collapse
        if (!this.opened || this.lazy) {
            return "gemini-tools/add";
        }
        else {
            return "gemini-tools/minus";
        }
    };
    /**
     * When a checkbox is clicked, it state changes and so it's children, and parent items do.
     * First evaluate the children, and then the parent items.
     */
    checkboxClickedHandler = () => {
        if (this.checkbox) {
            this.checked = !this.checked;
            if (!this.leaf) {
                this.toggleChildrenCheckboxes(this.checked);
            }
            const parentItems = this.getParentItems();
            parentItems.forEach(parentItem => {
                parentItem.evaluateCheckboxStatus();
            });
        }
    };
    toggleChildrenCheckboxes = (checked) => {
        this.indeterminate = false;
        const allChildren = this.el.querySelectorAll("gxg-tree-item");
        if (allChildren?.length) {
            Array.from(allChildren).forEach(item => {
                item.indeterminate = false;
                item.checked = checked;
            });
        }
    };
    getParentItems = () => {
        const parentItems = [];
        let parentItem = this.el.parentElement.parentElement;
        while (parentItem?.nodeName === "GXG-TREE-ITEM") {
            parentItems.push(parentItem);
            parentItem = parentItem.parentElement?.parentElement;
        }
        return parentItems;
    };
    getParentsNumber = () => {
        let count = 0;
        let parentElement = this.el.parentElement;
        while (parentElement?.nodeName === "GXG-TREE") {
            count++;
            parentElement = parentElement.parentElement?.parentElement;
        }
        return count;
    };
    getChildrenNumber = () => {
        if (this.numberOfChildren === 0) {
            //If this.numberOfChildren === 0 it might be because the whole tree was created with markup, and not by passing a model. In that case, count the children with querySelectorAll.
            return this.el.querySelectorAll("gxg-tree-item").length;
        }
    };
    toggleClickedHandler = () => {
        if (this.lazy && !this.opened) {
            this.downloading = true;
            this.toggleIconClicked.emit(this.getItemData());
        }
        if (!this.lazy) {
            this.opened = !this.opened;
        }
    };
    getItemData = (ctrl = false) => {
        return {
            ref: this.el,
            checkbox: this.checkbox,
            checked: this.checked,
            ctrl: ctrl,
            description: this.description,
            disabled: this.disabled,
            icon: this.icon,
            id: this.id,
            indeterminate: this.indeterminate,
            label: this.label,
            lazy: this.lazy,
            leaf: this.leaf,
            opened: this.opened,
            selected: this.selected
        };
    };
    // 10.RENDER() FUNCTION //
    render() {
        return (h(Host, { class: { leaf: this.leaf, "not-leaf": !this.leaf }, exportParts: this.exportparts ? this.exportparts : null }, h("li", { class: {
                "tree-open": this.opened,
                "tree-closed": !this.opened,
                disabled: this.disabled
            } }, h("div", { class: {
                "li-text": true,
                "li-text--not-leaf": !this.leaf,
                "li-text--leaf": this.leaf,
                "li-text--first-tree-item": this.firstItem,
                "li-text--has-child-tree": this.hasChildTree,
                "li-text--selected": this.selected
            }, style: { paddingLeft: this.leftPadding }, onClick: this.liTextClickedHandler.bind(this), onDblClick: this.liTextDoubleClicked.bind(this), onKeyDown: this.liTextKeyDownPressed.bind(this), tabIndex: -1, part: this.parts.item }, !this.leaf
            ? [
                h("span", { class: { "vertical-line": true }, style: {
                        height: this.lineHeight,
                        left: this.verticalLineStartPosition
                    } }),
                h("div", { class: { "closed-opened-icons": true } }, h("gxg-icon", { onClick: this.toggleClickedHandler.bind(this), type: this.returnToggleIconType(), color: "auto", class: "icon toggle-icon", part: this.parts.toggleButton }))
            ]
            : null, this.numberOfParentTrees > 1 ? (h("span", { class: {
                "horizontal-line": true
            }, style: {
                left: this.horizontalLineStartPosition,
                width: this.horizontalLineWidth
            } })) : null, this.checkbox ? (h("gxg-form-checkbox", { checked: this.checked, class: { checkbox: true }, tabIndex: -1, indeterminate: this.indeterminate, disabled: this.disabled, onClick: this.checkboxClickedHandler, part: this.parts.checkbox })) : null, this.icon ? (h("gxg-icon", { type: this.icon, color: "auto", class: "icon icon--left", style: {
                "--icon-size": "14px"
            } })) : null, this.downloading && this.lazy ? (h("span", { class: "loading" })) : null, h("span", { class: "text" }, h("slot", null))), h("slot", { name: "tree" }), this.treeModel ? this.treeModel : null)));
    }
    static get is() { return "gxg-tree-item"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["gxg-tree-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["gxg-tree-item.css"]
        };
    }
    static get assetsDirs() { return ["tree-item-assets"]; }
    static get properties() {
        return {
            "checkbox": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set this attribute if you want this item to display a checkbox. This attribute is affected by the parent tree-item checkbox attribute, unless it is set in this item."
                },
                "attribute": "checkbox",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "checked": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set this attribute if you want this item to be checked by default. This attribute is affected by the parent tree-item checked attribute, unless it is set in this item."
                },
                "attribute": "checked",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "opened": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set this attribute if you want this items child tree to be opened by default. This attribute is affected by the parent tree-item opened attribute, unless it is set in this item."
                },
                "attribute": "opened",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "toggleCheckboxes": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set this attribute if you want all the children item's checkboxes to be toggled when this item checkbox is toggled. This attribute is affected by the parent tree-item toggleCheckboxes attribute, unless it is set in this item."
                },
                "attribute": "toggle-checkboxes",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "type": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This is the tree-item type/category. This attribute is affected by the parent tree type attribute, unless it is set in this item."
                },
                "attribute": "type",
                "reflect": false
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes this tree item disabled. This attribute is affected by the parent tree type attribute, unless it is set in this item."
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The tree item label."
                },
                "attribute": "label",
                "reflect": false
            },
            "description": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The tree item description."
                },
                "attribute": "description",
                "reflect": false
            },
            "leaf": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute indicates that this tree-item is a leaf, meaning it has no children items. If is not a leaf, it will display a +/- icon to toggle/ontoggle the children tree"
                },
                "attribute": "leaf",
                "reflect": false,
                "defaultValue": "false"
            },
            "selected": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute sets the tree-item as selected"
                },
                "attribute": "selected",
                "reflect": false,
                "defaultValue": "false"
            },
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Sets the tree item icon"
                },
                "attribute": "icon",
                "reflect": false
            },
            "treeModel": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "HTMLGxgTreeElement",
                    "resolved": "HTMLGxgTreeElement",
                    "references": {
                        "HTMLGxgTreeElement": {
                            "location": "global",
                            "id": "global::HTMLGxgTreeElement"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property is for passing a tree structure from the tree."
                }
            },
            "numberOfChildren": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property is for internal use, when using the treeModel."
                },
                "attribute": "number-of-children",
                "reflect": false,
                "defaultValue": "0"
            },
            "hasChildTree": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property is for internal use. It indicates that the item has children."
                },
                "attribute": "has-child-tree",
                "reflect": false,
                "defaultValue": "false"
            },
            "indeterminate": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property is for internal use. It indicates that the checkbox has an indeterminate state."
                },
                "attribute": "indeterminate",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "horizontalLinePaddingLeft": {},
            "lastTreeItem": {},
            "lastTreeItemOfParentTree": {},
            "numberOfVisibleDescendantItems": {},
            "time": {},
            "lineHeight": {},
            "downloading": {}
        };
    }
    static get events() {
        return [{
                "method": "checkboxToggled",
                "name": "checkboxToggled",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the checkbox was toggled"
                },
                "complexType": {
                    "original": "GxgTreeItemData",
                    "resolved": "{ ref?: HTMLGxgTreeItemElement; checkbox?: boolean; checked?: boolean; ctrl?: boolean; description?: string; disabled?: boolean; icon?: string; id: string; indeterminate?: boolean; items?: GxgTreeItemData[]; label: string; lazy?: boolean; leaf?: boolean; opened?: boolean; selected?: boolean; }",
                    "references": {
                        "GxgTreeItemData": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/tree-item/gxg-tree-item.tsx",
                            "id": "src/components/tree-item/gxg-tree-item.tsx::GxgTreeItemData"
                        }
                    }
                }
            }, {
                "method": "doubleClicked",
                "name": "doubleClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the item was double-clicked"
                },
                "complexType": {
                    "original": "GxgTreeItemData",
                    "resolved": "{ ref?: HTMLGxgTreeItemElement; checkbox?: boolean; checked?: boolean; ctrl?: boolean; description?: string; disabled?: boolean; icon?: string; id: string; indeterminate?: boolean; items?: GxgTreeItemData[]; label: string; lazy?: boolean; leaf?: boolean; opened?: boolean; selected?: boolean; }",
                    "references": {
                        "GxgTreeItemData": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/tree-item/gxg-tree-item.tsx",
                            "id": "src/components/tree-item/gxg-tree-item.tsx::GxgTreeItemData"
                        }
                    }
                }
            }, {
                "method": "lazyChanged",
                "name": "lazyChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the item is not lazy anymore"
                },
                "complexType": {
                    "original": "GxgTreeItemData",
                    "resolved": "{ ref?: HTMLGxgTreeItemElement; checkbox?: boolean; checked?: boolean; ctrl?: boolean; description?: string; disabled?: boolean; icon?: string; id: string; indeterminate?: boolean; items?: GxgTreeItemData[]; label: string; lazy?: boolean; leaf?: boolean; opened?: boolean; selected?: boolean; }",
                    "references": {
                        "GxgTreeItemData": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/tree-item/gxg-tree-item.tsx",
                            "id": "src/components/tree-item/gxg-tree-item.tsx::GxgTreeItemData"
                        }
                    }
                }
            }, {
                "method": "selectionChanged",
                "name": "selectionChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the icon selection was changes"
                },
                "complexType": {
                    "original": "GxgTreeItemData",
                    "resolved": "{ ref?: HTMLGxgTreeItemElement; checkbox?: boolean; checked?: boolean; ctrl?: boolean; description?: string; disabled?: boolean; icon?: string; id: string; indeterminate?: boolean; items?: GxgTreeItemData[]; label: string; lazy?: boolean; leaf?: boolean; opened?: boolean; selected?: boolean; }",
                    "references": {
                        "GxgTreeItemData": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/tree-item/gxg-tree-item.tsx",
                            "id": "src/components/tree-item/gxg-tree-item.tsx::GxgTreeItemData"
                        }
                    }
                }
            }, {
                "method": "toggleIconClicked",
                "name": "toggleIconClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the toggle icon was clicked"
                },
                "complexType": {
                    "original": "GxgTreeItemData",
                    "resolved": "{ ref?: HTMLGxgTreeItemElement; checkbox?: boolean; checked?: boolean; ctrl?: boolean; description?: string; disabled?: boolean; icon?: string; id: string; indeterminate?: boolean; items?: GxgTreeItemData[]; label: string; lazy?: boolean; leaf?: boolean; opened?: boolean; selected?: boolean; }",
                    "references": {
                        "GxgTreeItemData": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/tree-item/gxg-tree-item.tsx",
                            "id": "src/components/tree-item/gxg-tree-item.tsx::GxgTreeItemData"
                        }
                    }
                }
            }];
    }
    static get methods() {
        return {
            "reRender": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            },
            "evaluateCheckboxStatus": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {},
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "checked",
                "methodName": "checkedHandler"
            }, {
                "propName": "opened",
                "methodName": "openedHandler"
            }];
    }
}
//# sourceMappingURL=gxg-tree-item.js.map
